import {
  ContactType,
  RoiSmsData,
} from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { demoDataUtils } from '../../../utils';

const pageLimit = 10;
const contactTypes: ContactType[] = [
  ContactType.EXISTING_PATIENT,
  ContactType.NEW_PATIENT,
  ContactType.UNSHEDULED_PATIENT,
];
const appointmentsTypes = ['OrthVisit', 'Post Op', 'PeriodicX, ProphyAd', 'ProphyAd'];

export const patientsDemoData = (locationIds: string[]): RoiSmsData[] => {
  // This limit is used to generate the number of patients for each location
  const locationIdLimit = Math.floor(pageLimit / locationIds.length);
  const dummyUserNames = demoDataUtils.generateRandomUserNames(25);

  return locationIds.reduce<RoiSmsData[]>((acc, locationId) => {
    for (let i = 0; i < locationIdLimit; i++) {
      acc.push({
        appointmentType: appointmentsTypes[i % appointmentsTypes.length],
        apptsCompletionDate: demoDataUtils.getRandomDateAndTime(),
        contactType: contactTypes[i % contactTypes.length],
        entryDate: demoDataUtils.getRandomDateAndTime(),
        locationId: locationId,
        messageDetails: 'This is a dummy message text', // Translation not needed
        patientId: demoDataUtils.generateRandomUUID(),
        patientName: `${dummyUserNames[demoDataUtils.generateRandomInt(0, 24)].firstName} ${
          dummyUserNames[demoDataUtils.generateRandomInt(0, 24)].lastName
        }`,
        phoneNumber: demoDataUtils.generateRandomNumberString(10),
        practitionerName: `${dummyUserNames[demoDataUtils.generateRandomInt(0, 24)].firstName} ${
          dummyUserNames[demoDataUtils.generateRandomInt(0, 24)].lastName
        }`,
        receiverNumber: demoDataUtils.generateRandomNumberString(10),
        senderNumber: demoDataUtils.generateRandomNumberString(10),
      });
    }

    return acc;
  }, []);
};
